import { Table, TableBody, TableHead, TableRow, Tooltip } from '@mui/material';

import {
  ActionIconButton,
  GeneralTableBox,
  NoDataSkeleton,
  RowTableCell,
  SortableHeadTableCell,
  TableBodySkeleton,
} from '../../../common/components';
import { PROVIDER_TEXTS as TEXTS } from '../constants/providersConstants';

const MIN_TABLE_WIDTH = 1080;
const textSx = { textAlign: 'left' };

const COLUMNS = [
  { sortKey: 'legal_business_name', label: TEXTS.legalBusinessName, sx: textSx },
  { sortKey: 'company', label: TEXTS.company, sx: { ...textSx, width: 220 } },
  { sortKey: 'cuit', label: TEXTS.cuit, sx: { ...textSx, width: 140 } },
  { sortKey: 'phone_number', label: TEXTS.phone, sx: { ...textSx, width: 150 } },
  { sortKey: 'email', label: TEXTS.email, sx: { ...textSx, width: 220 } },
  { sortKey: 'contact_information', label: TEXTS.contact, sx: { ...textSx, width: 180 } },
  { label: TEXTS.actions, sx: { width: 110 } },
];

const FIELDS = [
  'legal_business_name',
  'company',
  'cuit',
  'phone_number',
  'email',
  'contact_information',
];

/**
 * Tabla de proveedores de materiales, ordenable por columna.
 * @param {Object} props
 * @param {Array<Object>} props.providers Proveedores de la página.
 * @param {boolean} props.isLoading Carga inicial.
 * @param {Object|null} props.sort Orden vigente.
 * @param {Function} props.onSort Recibe la columna clickeada.
 * @param {Function} props.onEdit Abre el drawer de edición.
 * @param {Function} props.onRemove Pide confirmación para quitar de proveedores.
 * @returns {JSX.Element}
 */
const ProvidersDataTable = ({ providers, isLoading, sort, onSort, onEdit, onRemove }) => (
  <GeneralTableBox fixedLayout minTableWidth={MIN_TABLE_WIDTH}>
    <Table stickyHeader size="small">
      <TableHead>
        <TableRow>
          {COLUMNS.map((column) => (
            <SortableHeadTableCell
              key={column.label}
              sortKey={column.sortKey}
              sort={sort}
              onSort={onSort}
              sx={column.sx}
            >
              {column.label}
            </SortableHeadTableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading ? (
          <TableBodySkeleton />
        ) : providers.length ? (
          providers.map((provider) => (
            <TableRow key={provider.uuid} hover>
              {FIELDS.map((field) => (
                <RowTableCell
                  key={field}
                  sx={{
                    ...textSx,
                    ...(field === 'legal_business_name' ? { fontWeight: 700 } : {}),
                  }}
                  title={provider[field] || ''}
                >
                  {provider[field] || '-'}
                </RowTableCell>
              ))}
              <RowTableCell>
                <Tooltip title={TEXTS.edit}>
                  <span>
                    <ActionIconButton variant="edit" onClick={() => onEdit(provider)} />
                  </span>
                </Tooltip>
                <Tooltip title={TEXTS.remove}>
                  <span>
                    <ActionIconButton variant="unlink" onClick={() => onRemove(provider)} />
                  </span>
                </Tooltip>
              </RowTableCell>
            </TableRow>
          ))
        ) : (
          <NoDataSkeleton colSpan={COLUMNS.length} message={TEXTS.empty} />
        )}
      </TableBody>
    </Table>
  </GeneralTableBox>
);

export default ProvidersDataTable;
